import { render, staticRenderFns } from "./BaseSimpleSuggest.vue?vue&type=template&id=58760778&scoped=true&"
import script from "./BaseSimpleSuggest.vue?vue&type=script&lang=js&"
export * from "./BaseSimpleSuggest.vue?vue&type=script&lang=js&"
import style0 from "./BaseSimpleSuggest.vue?vue&type=style&index=0&id=58760778&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58760778",
  null
  
)

export default component.exports